/** Console strings — bilingual by construction (doc 10). */
import type { Localized } from '@servicesai/ui';

export const S = {
  console: { en: 'ServicesAI Console', ar: 'وحدة تحكم ServicesAI' },
  ministry: { en: 'Ministry of Energy & Infrastructure', ar: 'وزارة الطاقة والبنية التحتية' },
  navOperations: { en: 'Operations', ar: 'العمليات' },
  navEngagement: { en: 'Engagement', ar: 'التواصل' },
  navPlatform: { en: 'Platform', ar: 'المنصة' },
  envSandbox: { en: 'Sandbox', ar: 'بيئة تجريبية' },
  dashboard: { en: 'Dashboard', ar: 'لوحة المعلومات' },
  queues: { en: 'Review queues', ar: 'قوائم المراجعة' },
  approvals: { en: 'Approvals', ar: 'الموافقات' },
  services: { en: 'Services', ar: 'الخدمات' },
  cxone: { en: 'NICE CXone', ar: 'NICE CXone' },
  signedInAs: { en: 'Acting as', ar: 'الدخول باسم' },
  selectStaffMember: { en: 'Choose a staff member…', ar: 'اختر موظفاً…' },
  enterStaffToken: { en: 'Paste your staff access token', ar: 'الصق رمز وصول الموظف' },
  authGateTitle: { en: 'Sign in to the console', ar: 'تسجيل الدخول إلى وحدة التحكم' },
  authGateHint: {
    en: 'Choose a staff member for quick access to the console.',
    ar: 'اختر موظفاً للوصول السريع إلى وحدة التحكم.',
  },
  authGateTokenHint: {
    en: 'Enter the staff access token issued for this environment.',
    ar: 'أدخل رمز وصول الموظف الصادر لهذه البيئة.',
  },
  authGateInvalid: {
    en: 'Could not sign in as that staff member. Choose another staff member and try again.',
    ar: 'تعذر تسجيل الدخول باسم هذا الموظف. اختر موظفاً آخر وحاول مرة أخرى.',
  },
  authGateSubmit: { en: 'Sign in', ar: 'تسجيل الدخول' },
  authGateChecking: { en: 'Checking…', ar: 'جارٍ التحقق…' },
  customers: { en: 'Customers', ar: 'المتعاملون' },
  customerSearch: { en: 'Search by name, phone, or Emirates ID…', ar: 'ابحث بالاسم أو الهاتف أو الهوية…' },
  noCustomers: { en: 'No customers found', ar: 'لا يوجد متعاملون' },
  noCustomersHint: { en: 'Try a different search.', ar: 'جرّب بحثاً آخر.' },
  openProfile: { en: 'Open profile', ar: 'عرض الملف' },
  applicationsLabel: { en: 'applications', ar: 'طلبات' },
  conversationsLabel: { en: 'conversations', ar: 'محادثات' },
  documentsLabel: { en: 'Documents', ar: 'المستندات' },
  consentsLabel: { en: 'Consents', ar: 'الموافقات' },
  timelineLabel: { en: 'Interaction timeline', ar: 'سجل التفاعلات' },
  messages: { en: 'messages', ar: 'رسائل' },
  revoked: { en: 'revoked', ar: 'ملغى' },
  none: { en: 'None yet', ar: 'لا يوجد بعد' },
  connecting: { en: 'Loading…', ar: 'جاري التحميل…' },

  // queues
  reference: { en: 'Reference', ar: 'الرقم المرجعي' },
  service: { en: 'Service', ar: 'الخدمة' },
  stage: { en: 'Stage', ar: 'المرحلة' },
  status: { en: 'Status', ar: 'الحالة' },
  due: { en: 'SLA due', ar: 'الموعد النهائي' },
  overdue: { en: 'Overdue', ar: 'متأخر' },
  priority: { en: 'Priority', ar: 'الأولوية' },
  channel: { en: 'Channel', ar: 'القناة' },
  all: { en: 'All', ar: 'الكل' },
  emptyQueue: { en: 'No cases in this view', ar: 'لا توجد حالات في هذا العرض' },
  emptyQueueHint: { en: 'Submitted applications appear here for review.', ar: 'تظهر الطلبات المقدمة هنا للمراجعة.' },
  openCase: { en: 'Open case', ar: 'فتح الحالة' },

  // case file
  caseFile: { en: 'Case file', ar: 'ملف الحالة' },
  backToQueues: { en: 'Back to queues', ar: 'العودة إلى القوائم' },
  submitted: { en: 'Submitted', ar: 'تاريخ التقديم' },
  sections: { en: 'Review sections', ar: 'أقسام المراجعة' },
  agree: { en: 'Agree', ar: 'موافقة' },
  correct: { en: 'Correct', ar: 'تصحيح' },
  returnVerb: { en: 'Return', ar: 'إعادة' },
  agreed: { en: 'Agreed', ar: 'تمت الموافقة' },
  corrected: { en: 'Corrected', ar: 'تم التصحيح' },
  returnedState: { en: 'Returned', ar: 'أُعيد' },
  provenance: { en: 'Source', ar: 'المصدر' },
  extracted: { en: 'Extracted', ar: 'مستخرج' },
  confidence: { en: 'confidence', ar: 'الثقة' },
  attachedDoc: { en: 'Attached', ar: 'مرفق' },
  missingDoc: { en: 'Missing', ar: 'غير مرفق' },
  notRequired: { en: 'Not required', ar: 'غير مطلوب' },
  transcript: { en: 'Conversation', ar: 'المحادثة' },
  timeline: { en: 'Timeline', ar: 'الخط الزمني' },
  eligibility: { en: 'Eligibility', ar: 'الأهلية' },
  fieldToCorrect: { en: 'Field', ar: 'الحقل' },
  newValue: { en: 'New value', ar: 'القيمة الجديدة' },
  reason: { en: 'Reason (audited)', ar: 'السبب (مسجل)' },
  saveCorrection: { en: 'Save correction', ar: 'حفظ التصحيح' },
  cancel: { en: 'Cancel', ar: 'إلغاء' },
  returnTitle: { en: 'Return to citizen', ar: 'إعادة إلى المتعامل' },
  returnHelp: {
    en: 'The comment is sent to the citizen in their language — both are required.',
    ar: 'يُرسل التعليق إلى المتعامل بلغته — كلا النصين مطلوب.',
  },
  commentEn: { en: 'Comment (English)', ar: 'التعليق (بالإنجليزية)' },
  commentAr: { en: 'Comment (Arabic)', ar: 'التعليق (بالعربية)' },
  sendReturn: { en: 'Return application', ar: 'إعادة الطلب' },
  recommend: { en: 'Recommendation', ar: 'التوصية' },
  recommendHelp: {
    en: 'Review every section first. The decision executes only after a different approver signs it.',
    ar: 'راجع جميع الأقسام أولاً. يُنفَّذ القرار فقط بعد توقيع معتمد آخر.',
  },
  recommendApprove: { en: 'Recommend approval', ar: 'التوصية بالموافقة' },
  recommendReject: { en: 'Recommend rejection', ar: 'التوصية بالرفض' },
  reasonEn: { en: 'Reason (English)', ar: 'السبب (بالإنجليزية)' },
  reasonAr: { en: 'Reason (Arabic)', ar: 'السبب (بالعربية)' },
  sentToApprover: { en: 'Sent to the approvals inbox', ar: 'أُرسلت إلى صندوق الموافقات' },
  noAssignment: { en: 'No open review assignment for this case.', ar: 'لا توجد مهمة مراجعة مفتوحة لهذه الحالة.' },

  // approvals
  approvalsTitle: { en: 'Approvals inbox', ar: 'صندوق الموافقات' },
  approvalsHint: {
    en: 'Maker-checker: you cannot sign your own request.',
    ar: 'صانع-مدقق: لا يمكنك توقيع طلبك الخاص.',
  },
  maker: { en: 'Requested by', ar: 'مقدم الطلب' },
  kind: { en: 'Type', ar: 'النوع' },
  approve: { en: 'Approve & execute', ar: 'اعتماد وتنفيذ' },
  reject: { en: 'Reject', ar: 'رفض' },
  rejectNote: { en: 'Rejection note', ar: 'سبب الرفض' },
  emptyApprovals: { en: 'Nothing waiting for approval', ar: 'لا توجد طلبات بانتظار الاعتماد' },
  kindServicePublish: { en: 'Service publish', ar: 'نشر خدمة' },
  kindDecision: { en: 'Application decision', ar: 'قرار طلب' },
  expires: { en: 'Expires', ar: 'تنتهي' },

  // services / builder
  servicesTitle: { en: 'Service registry', ar: 'سجل الخدمات' },
  version: { en: 'Version', ar: 'الإصدار' },
  draft: { en: 'Draft', ar: 'مسودة' },
  published: { en: 'Published', ar: 'منشورة' },
  openBuilder: { en: 'Open in builder', ar: 'فتح في المنشئ' },
  builder: { en: 'Service Builder', ar: 'منشئ الخدمات' },
  specEditor: { en: 'Spec (ServiceSpec v2 JSON)', ar: 'المواصفة (ServiceSpec v2 JSON)' },
  validate: { en: 'Validate', ar: 'تحقق' },
  saveDraft: { en: 'Save draft', ar: 'حفظ المسودة' },
  publishForApproval: { en: 'Submit for publish', ar: 'إرسال للنشر' },
  changelog: { en: 'Changelog', ar: 'سجل التغييرات' },
  specValid: { en: 'Spec is valid', ar: 'المواصفة صحيحة' },
  issues: { en: 'Issues', ar: 'الملاحظات' },
  draftSaved: { en: 'Draft saved', ar: 'تم حفظ المسودة' },
  simulator: { en: 'Simulator', ar: 'المحاكي' },
  simulatorHint: {
    en: 'Runs the real engine against the published spec in simulation mode — nothing reaches the live queues.',
    ar: 'يشغّل المحرك الفعلي على المواصفة المنشورة في وضع المحاكاة — لا يصل أي شيء إلى القوائم الفعلية.',
  },
  startSimEn: { en: 'Simulate in English', ar: 'محاكاة بالإنجليزية' },
  startSimAr: { en: 'Simulate in Arabic', ar: 'محاكاة بالعربية' },
  simType: { en: 'Type a reply…', ar: 'اكتب رداً…' },
  simSend: { en: 'Send', ar: 'إرسال' },
  simAttach: { en: 'Attach sample document', ar: 'إرفاق مستند تجريبي' },
  simReset: { en: 'Reset', ar: 'إعادة تعيين' },

  // dashboard
  dashboardTitle: { en: 'Operations dashboard', ar: 'لوحة العمليات' },
  byState: { en: 'Applications by state', ar: 'الطلبات حسب الحالة' },
  queueDepth: { en: 'Queue depth', ar: 'عمق القوائم' },
  skipToContent: { en: 'Skip to main content', ar: 'تخطَّ إلى المحتوى الرئيسي' },
  notCompleted: { en: 'Not-completed transactions', ar: 'المعاملات غير المكتملة' },
  draftsInProgress: { en: 'Drafts / in progress', ar: 'مسودات / قيد الإنجاز' },
  abandoned: { en: 'Abandoned (inactivity)', ar: 'متروكة (عدم نشاط)' },
  securityPanel: { en: 'Security & assurance', ar: 'الأمن والموثوقية' },
  securityScore: { en: 'Security score', ar: 'مؤشر الأمن' },
  securityEvents24h: { en: 'Security events (24h)', ar: 'أحداث أمنية (٢٤ ساعة)' },
  openIncidents: { en: 'Open incidents', ar: 'حوادث مفتوحة' },
  moderation7d: { en: 'Moderation (7d)', ar: 'الرصد اللغوي (٧ أيام)' },
  overrideRate: { en: 'Correction rate', ar: 'معدل التصحيح' },
  decided: { en: 'Decisions issued', ar: 'القرارات الصادرة' },
  avgHours: { en: 'Avg decision hours', ar: 'متوسط ساعات القرار' },
  auditVerify: { en: 'Verify audit chain', ar: 'التحقق من سلسلة التدقيق' },
  auditOk: { en: 'Audit chain intact', ar: 'سلسلة التدقيق سليمة' },
  auditBroken: { en: 'AUDIT CHAIN BROKEN', ar: 'سلسلة التدقيق مكسورة' },
  rows: { en: 'rows', ar: 'صفوف' },

  loadFailed: { en: 'Could not load — check the API and your role.', ar: 'تعذر التحميل — تحقق من الواجهة وصلاحياتك.' },
  actionFailed: { en: 'Action failed', ar: 'فشل الإجراء' },

  // agents
  agents: { en: 'AI Agents', ar: 'وكلاء الذكاء' },
  agentsTitle: { en: 'AI Agents', ar: 'وكلاء الذكاء الاصطناعي' },
  agentsHint: {
    en: 'Govern the complete AI agent portfolio, from live journey assistants to scheduled operational intelligence.',
    ar: 'إدارة محفظة وكلاء الذكاء الاصطناعي كاملة، من مساعدي الرحلة المباشرة إلى الذكاء التشغيلي المجدول.',
  },
  journeyTeam: { en: 'Journey agents', ar: 'وكلاء الرحلة' },
  backOfficeTeam: { en: 'Back-office agents', ar: 'وكلاء المكاتب الخلفية' },
  runNow: { en: 'Run now', ar: 'تشغيل الآن' },
  running: { en: 'Running…', ar: 'جاري التشغيل…' },
  lastRun: { en: 'Last run', ar: 'آخر تشغيل' },
  neverRun: { en: 'Not run yet', ar: 'لم يُشغّل بعد' },
  inEngine: { en: 'Acts in the live service', ar: 'يعمل ضمن الخدمة الحية' },
  openAgent: { en: 'Open', ar: 'فتح' },
  backToAgents: { en: 'Back to agents', ar: 'العودة إلى الوكلاء' },
  latestReport: { en: 'Latest report', ar: 'أحدث تقرير' },
  runHistory: { en: 'Run history', ar: 'سجل التشغيل' },
  noRuns: { en: 'No runs yet — press Run now.', ar: 'لا توجد عمليات تشغيل — اضغط تشغيل الآن.' },
  responsibilities: { en: 'Responsibilities', ar: 'المهام' },
  complaintsQueue: { en: 'Complaints queue', ar: 'قائمة الشكاوى' },
  probeTranscript: { en: 'Probe transcripts', ar: 'محاضر الاختبار' },
  succeeded: { en: 'Succeeded', ar: 'نجح' },
  failed: { en: 'Failed', ar: 'فشل' },
  chatWithAgent: { en: 'Chat with this agent', ar: 'تحدث مع هذا الوكيل' },
  askPlaceholder: { en: 'Ask this agent…', ar: 'اسأل هذا الوكيل…' },
  agentWorkspace: { en: 'Agent workspace', ar: 'مساحة عمل الوكيل' },
  agentWorkspaceLoading: { en: 'Loading governed configuration and operations…', ar: 'جارٍ تحميل الإعدادات والعمليات المحكومة…' },
  agentWorkspaceSections: { en: 'Agent workspace sections', ar: 'أقسام مساحة عمل الوكيل' },
  agentTabOverview: { en: 'Overview', ar: 'نظرة عامة' },
  agentTabOperations: { en: 'Operations', ar: 'العمليات' },
  agentTabActivity: { en: 'Activity', ar: 'النشاط' },
  agentTabPrompt: { en: 'Prompt & guidance', ar: 'الموجه والإرشادات' },
  agentTabNotes: { en: 'Notes & context', ar: 'الملاحظات والسياق' },
  agentTabIntegrations: { en: 'Integrations', ar: 'التكاملات' },
  agentTabAutomations: { en: 'Automations', ar: 'الأتمتة' },
  agentTabReporting: { en: 'Reporting', ar: 'التقارير' },
  agentTabAudit: { en: 'Audit', ar: 'التدقيق' },
  agentTabGovernance: { en: 'Test & governance', ar: 'الاختبار والحوكمة' },
  agentAuditTitle: { en: 'Agent audit trail', ar: 'مسار تدقيق الوكيل' },
  agentAuditSubtitle: {
    en: 'Hash-chained write, read, chat and run actions for this agent. Chat entries store metadata only — never message bodies.',
    ar: 'إجراءات الكتابة والقراءة والمحادثة والتشغيل المرتبطة تشفيرياً لهذا الوكيل. قيود المحادثة تحتفظ بالبيانات الوصفية فقط دون نصوص الرسائل.',
  },
  agentAuditEntries: { en: 'entries', ar: 'قيود' },
  agentAuditAll: { en: 'All', ar: 'الكل' },
  agentAuditWrite: { en: 'Write', ar: 'كتابة' },
  agentAuditRead: { en: 'Read', ar: 'قراءة' },
  agentAuditChat: { en: 'Chat', ar: 'محادثة' },
  agentAuditRun: { en: 'Run', ar: 'تشغيل' },
  agentAuditTime: { en: 'Time', ar: 'الوقت' },
  agentAuditCategory: { en: 'Category', ar: 'الفئة' },
  agentAuditAction: { en: 'Action', ar: 'الإجراء' },
  agentAuditActor: { en: 'Actor', ar: 'المنفذ' },
  agentAuditSubject: { en: 'Subject', ar: 'الموضوع' },
  agentAuditDetail: { en: 'Detail', ar: 'التفاصيل' },
  agentAuditShowDetail: { en: 'View', ar: 'عرض' },
  agentAuditHideDetail: { en: 'Hide', ar: 'إخفاء' },
  agentAuditActionPrefix: { en: 'Action prefix…', ar: 'بادئة الإجراء…' },
  agentAuditActorKind: { en: 'Actor kind', ar: 'نوع المنفذ' },
  agentAuditAnyActor: { en: 'Any actor', ar: 'أي منفذ' },
  agentAuditEmpty: { en: 'No audit entries for this agent yet', ar: 'لا توجد قيود تدقيق لهذا الوكيل بعد' },
  agentAuditLoadMore: { en: 'Load older entries', ar: 'تحميل قيود أقدم' },
  agentPortfolio: { en: 'Agent portfolio', ar: 'محفظة الوكلاء' },
  agentRunnable: { en: 'Runnable agents', ar: 'الوكلاء القابلون للتشغيل' },
  agentHealthy: { en: 'Healthy', ar: 'سليم' },
  agentAttention: { en: 'Needs attention', ar: 'يتطلب الانتباه' },
  agentHealth: { en: 'Agent health', ar: 'صحة الوكيل' },
  agentType: { en: 'Agent type', ar: 'نوع الوكيل' },
  agentRegistered: { en: 'registered', ar: 'مسجل' },
  agentNoMetric: { en: 'No operational metric available', ar: 'لا يتوفر مؤشر تشغيلي' },
  agentManualScheduled: { en: 'Manual and scheduled operations', ar: 'عمليات يدوية ومجدولة' },
  agentBasedOnRun: { en: 'Based on latest execution', ar: 'استناداً إلى آخر تشغيل' },
  agentFailedRuns: { en: 'Latest execution failed', ar: 'فشل آخر تشغيل' },
  agentWorkspaces: { en: 'workspaces', ar: 'مساحات عمل' },
  allAgentTypes: { en: 'All agent types', ar: 'كل أنواع الوكلاء' },
  allHealthStates: { en: 'All health states', ar: 'كل حالات الصحة' },
  searchAgents: { en: 'Search agents by name, role, or identifier…', ar: 'ابحث عن وكيل بالاسم أو الدور أو المعرّف…' },
  noAgentsMatch: { en: 'No agents match these filters', ar: 'لا توجد وكلاء مطابقة لهذه المرشحات' },
  noAgentsMatchHint: { en: 'Clear a filter or try another search.', ar: 'امسح أحد المرشحات أو جرّب بحثاً آخر.' },
  openWorkspace: { en: 'Open workspace', ar: 'فتح مساحة العمل' },
  refresh: { en: 'Refresh', ar: 'تحديث' },
  agentRuns24h: { en: 'Runs (24h)', ar: 'التشغيلات (٢٤ ساعة)' },
  agentRuns24hHint: { en: 'Agents with a run in the last day', ar: 'وكلاء نُفذوا خلال اليوم الماضي' },
  agentEnabledHint: { en: 'Runtime switched on', ar: 'التشغيل مفعّل' },
  enabled: { en: 'Enabled', ar: 'مفعّل' },
  disabled: { en: 'Disabled', ar: 'معطّل' },
  totalRuns: { en: 'Total runs', ar: 'إجمالي التشغيلات' },
  lastHundredRuns: { en: 'Latest 100 retained executions', ar: 'آخر ١٠٠ عملية تشغيل محفوظة' },
  successRate: { en: 'Success rate', ar: 'معدل النجاح' },
  averageDuration: { en: 'Average duration', ar: 'متوسط المدة' },
  tokenUsage: { en: 'Token usage', ar: 'استهلاك الرموز' },
  agentSpecificReportHint: { en: 'Structured operational output for this agent type.', ar: 'مخرجات تشغيلية منظمة خاصة بنوع هذا الوكيل.' },
  healthProvenance: { en: 'Health & provenance', ar: 'الصحة والمصدر' },
  runtimeState: { en: 'Runtime state', ar: 'حالة التشغيل' },
  model: { en: 'Model', ar: 'النموذج' },
  configurationVersion: { en: 'Configuration version', ar: 'إصدار الإعداد' },
  nextSchedule: { en: 'Next schedule', ar: 'التشغيل القادم' },
  codeDefault: { en: 'Code default', ar: 'الإعداد البرمجي الافتراضي' },
  promptHash: { en: 'Prompt fingerprint', ar: 'بصمة الموجه' },
  grounding: { en: 'Grounding', ar: 'الاستناد' },
  required: { en: 'Required', ar: 'مطلوب' },
  optional: { en: 'Optional', ar: 'اختياري' },
  lastActivity: { en: 'Last activity', ar: 'آخر نشاط' },
  started: { en: 'Started', ar: 'بدأ' },
  trigger: { en: 'Trigger', ar: 'المشغّل' },
  grounded: { en: 'Grounded', ar: 'مستند' },
  notGrounded: { en: 'Not grounded', ar: 'غير مستند' },
  tokens: { en: 'Tokens', ar: 'الرموز' },
  duration: { en: 'Duration', ar: 'المدة' },
  activityHistory: { en: 'Run activity', ar: 'نشاط التشغيل' },
  activityHistoryHint: { en: 'Execution status, runtime provenance, grounding, and token usage.', ar: 'حالة التشغيل ومصدر الإعداد والاستناد واستهلاك الرموز.' },
  runs: { en: 'runs', ar: 'تشغيلات' },
  runErrors: { en: 'Run errors', ar: 'أخطاء التشغيل' },
  governanceSummary: { en: 'Governance controls', ar: 'ضوابط الحوكمة' },
  governanceSummaryHint: { en: 'Published safeguards and governed resources in effect.', ar: 'الضمانات والموارد المحكومة المنشورة والسارية.' },
  noActionApproval: { en: 'Actions do not require approval', ar: 'الإجراءات لا تتطلب اعتماداً' },
  configVersions: { en: 'Configuration versions', ar: 'إصدارات الإعداد' },
  approvalRequests: { en: 'Approval requests', ar: 'طلبات الاعتماد' },
  guardrails: { en: 'Guardrails', ar: 'ضوابط الحماية' },
  integrations: { en: 'Integrations', ar: 'التكاملات' },
  approvalsAudit: { en: 'Approvals & audit details', ar: 'تفاصيل الاعتمادات والتدقيق' },
  approvalsAuditHint: { en: 'Maker-checker history for configuration publication.', ar: 'سجل الصانع والمدقق لنشر الإعدادات.' },
  openApprovals: { en: 'Open approvals inbox', ar: 'فتح صندوق الاعتمادات' },
  noAgentApprovals: { en: 'No configuration approvals recorded', ar: 'لا توجد اعتمادات إعداد مسجلة' },
  risk: { en: 'Risk', ar: 'المخاطر' },
  noComplaints: { en: 'No complaints in this queue', ar: 'لا توجد شكاوى في هذه القائمة' },
  safeTestHint: { en: 'Safe try-it session using the current published configuration.', ar: 'جلسة اختبار آمنة باستخدام الإعداد المنشور حالياً.' },
  rawReport: { en: 'Raw report data', ar: 'بيانات التقرير الخام' },

  // agent workspace elevation (plan points 51–57)
  pinnedAgents: { en: 'Pinned', ar: 'مثبت' },
  pinAgent: { en: 'Pin this agent', ar: 'تثبيت هذا الوكيل' },
  unpinAgent: { en: 'Unpin this agent', ar: 'إلغاء تثبيت هذا الوكيل' },
  latestRunOutcome: { en: 'Latest run outcome', ar: 'نتيجة آخر تشغيل' },
  runDetails: { en: 'Run details', ar: 'تفاصيل التشغيل' },
  runDetailsHint: {
    en: 'Full execution provenance, token split, and timing for this run.',
    ar: 'المصدر الكامل للتشغيل وتقسيم الرموز والتوقيت لهذه العملية.',
  },
  openRunDetails: { en: 'Open run details', ar: 'عرض تفاصيل التشغيل' },
  closeRunDetails: { en: 'Close run details', ar: 'إغلاق تفاصيل التشغيل' },
  triggeredBy: { en: 'Triggered by', ar: 'جهة التشغيل' },
  scheduleLabel: { en: 'Schedule', ar: 'الجدولة' },
  promptTokens: { en: 'Prompt tokens', ar: 'رموز الموجه' },
  completionTokens: { en: 'Completion tokens', ar: 'رموز الإكمال' },
  configVersionId: { en: 'Config version id', ar: 'معرّف إصدار الإعداد' },
  copy: { en: 'Copy', ar: 'نسخ' },
  copied: { en: 'Copied', ar: 'تم النسخ' },
  finished: { en: 'Finished', ar: 'انتهى' },
  errorLabel: { en: 'Error', ar: 'الخطأ' },
  throughput: { en: 'Throughput', ar: 'الإنتاجية' },
  throughputHint: {
    en: 'Runs and tokens per day over the last 14 days — each series scaled to its own peak.',
    ar: 'عمليات التشغيل والرموز يومياً خلال آخر ١٤ يوماً — كل سلسلة بمقياس ذروتها.',
  },
  runsPerDay: { en: 'Runs / day', ar: 'تشغيلات / يوم' },
  tokensPerDay: { en: 'Tokens / day', ar: 'رموز / يوم' },
  throughputEmpty: { en: 'No runs in the last 14 days', ar: 'لا توجد تشغيلات خلال آخر ١٤ يوماً' },
  promptDiff: { en: 'Prompt diff', ar: 'مقارنة الموجه' },
  promptDiffHint: {
    en: 'Published vs draft prompt configuration, line by line.',
    ar: 'إعداد الموجه المنشور مقابل المسودة سطراً بسطر.',
  },
  noPublishedPrompt: {
    en: 'No published version yet — the draft is compared against an empty baseline.',
    ar: 'لا يوجد إصدار منشور بعد — تُقارن المسودة بأساس فارغ.',
  },
  diffAdded: { en: 'Only in draft', ar: 'في المسودة فقط' },
  diffRemoved: { en: 'Only in published', ar: 'في المنشور فقط' },
  diffChanged: { en: 'Changed', ar: 'متغيّر' },
  governanceTimeline: { en: 'Governance timeline', ar: 'الخط الزمني للحوكمة' },
  governanceTimelineHint: {
    en: 'Version events, approval decisions, and audit entries in one chronological feed.',
    ar: 'أحداث الإصدارات وقرارات الاعتماد وقيود التدقيق في سجل زمني واحد.',
  },
  timelineDraftCreated: { en: 'Draft created', ar: 'إنشاء مسودة' },
  timelineSubmitted: { en: 'Submitted for approval', ar: 'إرسال للاعتماد' },
  timelinePublished: { en: 'Version published', ar: 'نشر إصدار' },
  timelineRejected: { en: 'Submission rejected', ar: 'رفض الإرسال' },
  timelineApproval: { en: 'Approval decision', ar: 'قرار اعتماد' },
  timelineEmpty: { en: 'No governance events yet', ar: 'لا توجد أحداث حوكمة بعد' },
  testRun: { en: 'Test run', ar: 'تشغيل اختباري' },
  testRunHint: {
    en: 'Runs the real agent now — one guarded run at a time.',
    ar: 'يشغّل الوكيل الفعلي الآن — تشغيل واحد محكوم في كل مرة.',
  },
  testRunPlaceholder: {
    en: 'Optional custom input for this test run…',
    ar: 'إدخال مخصص اختياري لهذا التشغيل الاختباري…',
  },
  runTest: { en: 'Run test', ar: 'تشغيل الاختبار' },
  testRunLastStatus: { en: 'Last test run', ar: 'آخر تشغيل اختباري' },

  // agent configuration
  promptGuidance: { en: 'Prompt & guidance', ar: 'الموجه والإرشادات' },
  promptGuidanceHint: { en: 'Create a governed draft, validate it, and submit it through maker-checker approval.', ar: 'أنشئ مسودة محكومة وتحقق منها ثم أرسلها لاعتماد الصانع والمدقق.' },
  createDraft: { en: 'Create draft', ar: 'إنشاء مسودة' },
  discardDraft: { en: 'Discard draft', ar: 'حذف المسودة' },
  unsavedChanges: { en: 'Unsaved changes', ar: 'تغييرات غير محفوظة' },
  validating: { en: 'Validating…', ar: 'جارٍ التحقق…' },
  saving: { en: 'Saving…', ar: 'جارٍ الحفظ…' },
  submitForApproval: { en: 'Submit for approval', ar: 'إرسال للاعتماد' },
  saveBeforeSubmit: { en: 'Save changes before submitting.', ar: 'احفظ التغييرات قبل الإرسال.' },
  agentDraftCreated: { en: 'Draft created', ar: 'تم إنشاء المسودة' },
  agentDraftDiscarded: { en: 'Draft discarded', ar: 'تم حذف المسودة' },
  agentSubmitted: { en: 'Draft submitted for maker-checker approval', ar: 'تم إرسال المسودة لاعتماد الصانع والمدقق' },
  agentRollbackCreated: { en: 'Rollback draft created', ar: 'تم إنشاء مسودة الرجوع' },
  agentConfigValid: { en: 'Configuration is valid', ar: 'الإعداد صحيح' },
  simulateConfiguration: { en: 'Simulate', ar: 'محاكاة' },
  simulationPreview: { en: 'Configuration simulation', ar: 'محاكاة الإعداد' },
  promptPreview: { en: 'Resolved prompt preview', ar: 'معاينة الموجه النهائي' },
  bilingualGuidance: { en: 'Bilingual guidance', ar: 'الإرشادات ثنائية اللغة' },
  bilingualGuidanceHint: { en: 'Both language variants are required and are released together.', ar: 'كلا النصين مطلوبان ويتم إصدارهما معاً.' },
  guidanceEnglish: { en: 'Guidance (English)', ar: 'الإرشادات (بالإنجليزية)' },
  guidanceArabic: { en: 'Guidance (Arabic)', ar: 'الإرشادات (بالعربية)' },
  systemInstructions: { en: 'System instructions', ar: 'تعليمات النظام' },
  systemInstructionsHint: { en: 'Ordered bilingual policies applied to every response.', ar: 'سياسات ثنائية اللغة مرتبة تطبق على كل استجابة.' },
  addInstruction: { en: 'Add instruction', ar: 'إضافة تعليمات' },
  removeInstruction: { en: 'Remove instruction', ar: 'إزالة التعليمات' },
  english: { en: 'English', ar: 'الإنجليزية' },
  arabic: { en: 'Arabic', ar: 'العربية' },
  remove: { en: 'Remove', ar: 'إزالة' },
  runtimeControls: { en: 'Runtime controls', ar: 'ضوابط التشغيل' },
  runtimeControlsHint: { en: 'Model, generation limits, timeout, and response style.', ar: 'النموذج وحدود التوليد والمهلة وأسلوب الاستجابة.' },
  temperature: { en: 'Temperature', ar: 'درجة التنوع' },
  maxTokens: { en: 'Maximum tokens', ar: 'الحد الأقصى للرموز' },
  timeoutMs: { en: 'Timeout (milliseconds)', ar: 'المهلة (مللي ثانية)' },
  responseTone: { en: 'Response tone', ar: 'نبرة الاستجابة' },
  minSentences: { en: 'Minimum sentences', ar: 'الحد الأدنى للجمل' },
  maxSentences: { en: 'Maximum sentences', ar: 'الحد الأقصى للجمل' },
  guardrailsHint: { en: 'Published safety and human-oversight requirements.', ar: 'متطلبات السلامة والإشراف البشري المنشورة.' },
  requireGrounding: { en: 'Require grounding', ar: 'اشتراط الاستناد' },
  requireGroundingHint: { en: 'Responses must cite approved context.', ar: 'يجب أن تستند الردود إلى سياق معتمد.' },
  externalLookup: { en: 'Allow external lookup', ar: 'السماح بالبحث الخارجي' },
  externalLookupHint: { en: 'Permit approved external data retrieval.', ar: 'السماح باسترجاع بيانات خارجية معتمدة.' },
  redactPersonalData: { en: 'Redact personal data', ar: 'حجب البيانات الشخصية' },
  redactPersonalDataHint: { en: 'Remove personal data from model-visible text.', ar: 'إزالة البيانات الشخصية من النص المرئي للنموذج.' },
  humanApproval: { en: 'Human approval for actions', ar: 'اعتماد بشري للإجراءات' },
  humanApprovalHint: { en: 'Require a person before consequential actions.', ar: 'اشتراط تدخل بشري قبل الإجراءات المؤثرة.' },
  blockedTopics: { en: 'Blocked topics', ar: 'الموضوعات المحظورة' },
  onePerLine: { en: 'One topic per line', ar: 'موضوع واحد في كل سطر' },
  changeNote: { en: 'Change note', ar: 'ملاحظة التغيير' },
  changeNoteHint: { en: 'Explain the purpose and expected operational impact.', ar: 'اشرح الغرض والأثر التشغيلي المتوقع.' },
  versionHistory: { en: 'Version history', ar: 'سجل الإصدارات' },
  versionHistoryHint: { en: 'Compare published provenance or create a controlled rollback draft.', ar: 'قارن مصدر الإعداد المنشور أو أنشئ مسودة رجوع محكومة.' },
  updated: { en: 'Updated', ar: 'آخر تحديث' },
  actions: { en: 'Actions', ar: 'الإجراءات' },
  compare: { en: 'Compare', ar: 'مقارنة' },
  rollback: { en: 'Roll back', ar: 'رجوع' },
  discardDraftBeforeRollback: { en: 'Discard the current draft before rolling back.', ar: 'احذف المسودة الحالية قبل الرجوع.' },
  selectedPublishedVersion: { en: 'This is the currently published version.', ar: 'هذا هو الإصدار المنشور حالياً.' },
  loadingDiff: { en: 'Loading configuration diff…', ar: 'جارٍ تحميل فروقات الإعداد…' },
  configurationDiff: { en: 'Configuration diff', ar: 'فروقات الإعداد' },
  changes: { en: 'changes', ar: 'تغييرات' },
  noConfigurationChanges: { en: 'No configuration changes', ar: 'لا توجد تغييرات في الإعداد' },

  // agent notes
  notesContext: { en: 'Notes & context', ar: 'الملاحظات والسياق' },
  notesContextHint: { en: 'Maintain freeform operational context. Only explicitly selected saved notes are shared with configuration AI.', ar: 'احتفظ بسياق تشغيلي حر. لا تتم مشاركة سوى الملاحظات المحفوظة والمحددة صراحةً مع ذكاء الإعداد.' },
  showArchived: { en: 'Show archived', ar: 'عرض المؤرشف' },
  addNote: { en: 'Add note', ar: 'إضافة ملاحظة' },
  editNote: { en: 'Edit note', ar: 'تعديل الملاحظة' },
  noteComposerHint: { en: 'Record decisions, constraints, examples, or operating context.', ar: 'سجّل القرارات والقيود والأمثلة أو سياق التشغيل.' },
  note: { en: 'Note', ar: 'الملاحظة' },
  notePlaceholder: { en: 'Write freeform context for this agent…', ar: 'اكتب سياقاً حراً لهذا الوكيل…' },
  labels: { en: 'Labels', ar: 'التصنيفات' },
  labelsHint: { en: 'Comma-separated labels', ar: 'تصنيفات مفصولة بفواصل' },
  saveChanges: { en: 'Save changes', ar: 'حفظ التغييرات' },
  saveNote: { en: 'Save note', ar: 'حفظ الملاحظة' },
  selected: { en: 'selected', ar: 'محدد' },
  useWithConfigurationAi: { en: 'Use with configuration AI', ar: 'استخدام مع ذكاء إعداد الوكيل' },
  useWithConfigurationAiHint: { en: 'Select the exact saved notes the governed assistant may use as untrusted requirements context.', ar: 'حدد بدقة الملاحظات المحفوظة التي يجوز للمساعد المحكوم استخدامها كسياق متطلبات غير موثوق.' },
  noNotes: { en: 'No saved notes', ar: 'لا توجد ملاحظات محفوظة' },
  noArchivedNotes: { en: 'No archived notes', ar: 'لا توجد ملاحظات مؤرشفة' },
  noNotesHint: { en: 'Add operational context for future configuration work.', ar: 'أضف سياقاً تشغيلياً لأعمال الإعداد المستقبلية.' },
  noteCreated: { en: 'Note created', ar: 'تم إنشاء الملاحظة' },
  noteUpdated: { en: 'Note updated', ar: 'تم تحديث الملاحظة' },
  noteArchived: { en: 'Note archived', ar: 'تمت أرشفة الملاحظة' },
  archived: { en: 'Archived', ar: 'مؤرشف' },
  edit: { en: 'Edit', ar: 'تعديل' },
  archive: { en: 'Archive', ar: 'أرشفة' },

  // conversational agent configuration
  configurationAssistant: { en: 'Configure with AI', ar: 'إعداد الوكيل بالذكاء الاصطناعي' },
  configurationAssistantHint: { en: 'Draft, validate and preview governed changes conversationally.', ar: 'أنشئ تغييرات محكومة وتحقق منها وعاينها حوارياً.' },
  assistantDraftRequired: { en: 'Create an editable draft before asking AI to configure this agent.', ar: 'أنشئ مسودة قابلة للتعديل قبل أن تطلب من الذكاء الاصطناعي إعداد هذا الوكيل.' },
  assistantProposalMissing: { en: 'The configuration proposal is no longer available.', ar: 'لم يعد اقتراح الإعداد متاحاً.' },
  savedNotesContext: { en: 'Saved-note context', ar: 'سياق الملاحظات المحفوظة' },
  assistantNotesHint: { en: 'Only selected saved notes are sent. Unsaved text never leaves the browser.', ar: 'لا تُرسل سوى الملاحظات المحفوظة المحددة. لا يغادر النص غير المحفوظ المتصفح.' },
  configurationRequest: { en: 'What should change?', ar: 'ما الذي ينبغي تغييره؟' },
  configurationRequestPlaceholder: { en: 'For example: make the guidance more concise, keep human approval, and add a daily executive digest…', ar: 'مثال: اجعل الإرشادات أكثر إيجازاً، وأبقِ الاعتماد البشري، وأضف موجزاً تنفيذياً يومياً…' },
  generateProposal: { en: 'Generate governed proposal', ar: 'إنشاء اقتراح محكوم' },
  generatingProposal: { en: 'Generating and validating…', ar: 'جارٍ الإنشاء والتحقق…' },
  validated: { en: 'Validated', ar: 'تم التحقق' },
  invalid: { en: 'Invalid', ar: 'غير صالح' },
  noteProvenance: { en: 'Note provenance', ar: 'مصدر الملاحظات' },
  applyToDraft: { en: 'Apply to draft', ar: 'تطبيق على المسودة' },
  applyingProposal: { en: 'Applying…', ar: 'جارٍ التطبيق…' },
  assistantApprovalReminder: { en: 'Applying updates only the draft. Publishing still requires maker-checker approval.', ar: 'يؤدي التطبيق إلى تحديث المسودة فقط. ولا يزال النشر يتطلب اعتماد الصانع والمدقق.' },
  noDraft: { en: 'No draft', ar: 'لا توجد مسودة' },

  // agent integrations and automations
  resourcesNeedDraft: { en: 'Create a draft to add, edit, or remove governed resources.', ar: 'أنشئ مسودة لإضافة الموارد المحكومة أو تعديلها أو إزالتها.' },
  readOnlyPublished: { en: 'Published · read only', ar: 'منشور · للقراءة فقط' },
  agentIntegrations: { en: 'Integration bindings', ar: 'ارتباطات التكامل' },
  agentIntegrationsHint: { en: 'Bind approved adapters, scope capabilities, and test operational health.', ar: 'اربط المحولات المعتمدة وحدد القدرات واختبر الصحة التشغيلية.' },
  bindings: { en: 'bindings', ar: 'ارتباطات' },
  noIntegrationBindings: { en: 'No integrations bound', ar: 'لا توجد تكاملات مرتبطة' },
  noIntegrationBindingsHint: { en: 'Create a draft and bind an approved catalog adapter.', ar: 'أنشئ مسودة واربط محولاً معتمداً من السجل.' },
  integrationSaved: { en: 'Integration binding saved', ar: 'تم حفظ ارتباط التكامل' },
  integrationRequiredFields: { en: 'Adapter, display name, and at least one capability are required.', ar: 'المحول واسم العرض وقدرة واحدة على الأقل مطلوبة.' },
  secretReference: { en: 'Secret reference', ar: 'مرجع السر' },
  health: { en: 'Health', ar: 'الصحة' },
  testConnection: { en: 'Test', ar: 'اختبار' },
  disable: { en: 'Disable', ar: 'تعطيل' },
  enable: { en: 'Enable', ar: 'تفعيل' },
  editBinding: { en: 'Edit binding', ar: 'تعديل الارتباط' },
  addBinding: { en: 'Add binding', ar: 'إضافة ارتباط' },
  bindingFormHint: { en: 'Only catalog-approved capabilities and configuration keys are accepted.', ar: 'لا تُقبل إلا القدرات ومفاتيح الإعداد المعتمدة في السجل.' },
  catalogAdapter: { en: 'Catalog adapter', ar: 'محول السجل' },
  chooseAdapter: { en: 'Choose an approved adapter…', ar: 'اختر محولاً معتمداً…' },
  displayName: { en: 'Display name', ar: 'اسم العرض' },
  capabilities: { en: 'Capabilities', ar: 'القدرات' },
  scopesJson: { en: 'Scopes (JSON)', ar: 'النطاقات (JSON)' },
  configurationJson: { en: 'Configuration (JSON)', ar: 'الإعداد (JSON)' },
  allowedKeys: { en: 'Allowed keys', ar: 'المفاتيح المسموحة' },
  saveBinding: { en: 'Save binding', ar: 'حفظ الارتباط' },
  integrationCatalog: { en: 'Approved catalog', ar: 'السجل المعتمد' },
  integrationCatalogHint: { en: 'Adapters available to this agent, including capability and risk metadata.', ar: 'المحولات المتاحة لهذا الوكيل مع بيانات القدرات والمخاطر.' },
  automations: { en: 'Automations', ar: 'الأتمتة' },
  automationsHint: { en: 'Govern schedules, audiences, delivery windows, cooldowns, and retry policy.', ar: 'تحكم في الجداول والجمهور ونوافذ التسليم وفترات الانتظار وسياسة إعادة المحاولة.' },
  schedules: { en: 'schedules', ar: 'جداول' },
  noAutomations: { en: 'No automations configured', ar: 'لا توجد أتمتة معدّة' },
  noAutomationsHint: { en: 'Create a draft to add a governed schedule.', ar: 'أنشئ مسودة لإضافة جدول محكوم.' },
  automationSaved: { en: 'Automation saved', ar: 'تم حفظ الأتمتة' },
  scheduleRequiredFields: { en: 'Name, cron expression, and timezone are required.', ar: 'الاسم وتعبير الجدولة والمنطقة الزمنية مطلوبة.' },
  audience: { en: 'Audience', ar: 'الجمهور' },
  cooldown: { en: 'Cooldown', ar: 'فترة الانتظار' },
  retryPolicy: { en: 'Retry policy', ar: 'سياسة إعادة المحاولة' },
  editAutomation: { en: 'Edit automation', ar: 'تعديل الأتمتة' },
  addAutomation: { en: 'Add automation', ar: 'إضافة أتمتة' },
  automationFormHint: { en: 'Schedules are applied only after this configuration is approved and published.', ar: 'لا تُطبق الجداول إلا بعد اعتماد هذا الإعداد ونشره.' },
  scheduleName: { en: 'Schedule name', ar: 'اسم الجدول' },
  purpose: { en: 'Purpose', ar: 'الغرض' },
  cronExpression: { en: 'Cron expression', ar: 'تعبير Cron' },
  timezone: { en: 'Timezone', ar: 'المنطقة الزمنية' },
  preview: { en: 'Preview next runs', ar: 'معاينة التشغيلات القادمة' },
  audienceType: { en: 'Audience type', ar: 'نوع الجمهور' },
  audienceValues: { en: 'Audience values', ar: 'قيم الجمهور' },
  commaSeparated: { en: 'Comma-separated values', ar: 'قيم مفصولة بفواصل' },
  templateKey: { en: 'Template key', ar: 'مفتاح القالب' },
  cooldownMinutes: { en: 'Cooldown minutes', ar: 'دقائق الانتظار' },
  retryAttempts: { en: 'Retry attempts', ar: 'محاولات الإعادة' },
  retryBackoff: { en: 'Retry backoff (minutes)', ar: 'فاصل الإعادة (دقائق)' },
  quietHours: { en: 'Enable quiet hours', ar: 'تفعيل ساعات الهدوء' },
  quietStart: { en: 'Quiet hours start', ar: 'بداية ساعات الهدوء' },
  quietEnd: { en: 'Quiet hours end', ar: 'نهاية ساعات الهدوء' },
  conditionsJson: { en: 'Conditions (JSON)', ar: 'الشروط (JSON)' },
  saveAutomation: { en: 'Save automation', ar: 'حفظ الأتمتة' },

  // integrations hub + adapter detail
  integrationsTitle: { en: 'Integration catalog', ar: 'سجل التكاملات' },
  integrationsSubtitle: {
    en: 'Platform-wide adapter health, service dependencies and change blast radius.',
    ar: 'صحة محولات المنصة واعتماديات الخدمات ونطاق تأثير التغييرات.',
  },
  integrationAdapters: { en: 'Adapters', ar: 'المحولات' },
  integrationConnectedServices: { en: 'Connected services', ar: 'الخدمات المتصلة' },
  integrationLive: { en: 'Live', ar: 'مباشر' },
  integrationDegraded: { en: 'Degraded', ar: 'متدهور' },
  integrationAllKinds: { en: 'All kinds', ar: 'كل الفئات' },
  integrationOpen: { en: 'Open', ar: 'فتح' },
  integrationTopology: { en: 'Platform integration topology', ar: 'مخطط تكاملات المنصة' },
  integrationTopologyHint: {
    en: 'Select any adapter node to inspect the services that depend on it.',
    ar: 'حدد أي محول في المخطط لعرض الخدمات المعتمدة عليه.',
  },
  integrationBlastRadius: { en: 'Blast radius', ar: 'نطاق التأثير' },
  integrationDependentServices: { en: 'Dependent services', ar: 'الخدمات المعتمدة' },
  integrationDependentServicesLower: { en: 'dependent services', ar: 'خدمات معتمدة' },
  integrationDependentServicesHint: {
    en: 'Published services wired to this adapter.',
    ar: 'الخدمات المنشورة المرتبطة بهذا المحول.',
  },
  integrationNoDependents: {
    en: 'No published services currently depend on this adapter.',
    ar: 'لا تعتمد خدمات منشورة حالياً على هذا المحول.',
  },
  integrationsEmpty: { en: 'No integrations', ar: 'لا توجد تكاملات' },
  integrationsEmptyHint: {
    en: 'The catalog returned no adapters for this filter.',
    ar: 'لم يرجع السجل أي محولات مطابقة لهذا المرشح.',
  },
  integrationAdapter: { en: 'Integration adapter', ar: 'محول التكامل' },
  integrationKind: { en: 'Kind', ar: 'الفئة' },
  integrationHealthKeys: { en: 'Health keys', ar: 'مفاتيح الصحة' },
  integrationHealthTelemetry: { en: 'Health & telemetry', ar: 'الصحة والقياسات' },
  integrationHealthTelemetryHint: {
    en: 'Latest health payload reported by this adapter.',
    ar: 'أحدث بيانات الصحة التي أبلغ عنها هذا المحول.',
  },
  integrationNoHealth: {
    en: 'No health payload reported for this adapter.',
    ar: 'لم يُبلغ عن أي بيانات صحة لهذا المحول.',
  },
  integrationRawRecord: { en: 'Raw adapter record', ar: 'سجل المحول الخام' },
  integrationTopologyPosition: { en: 'Topology position', ar: 'الموقع في المخطط' },
  integrationTopologyPositionHint: {
    en: 'Platform connections that touch this adapter.',
    ar: 'اتصالات المنصة المرتبطة بهذا المحول.',
  },
  integrationNoConnections: {
    en: 'No topology connections reference this adapter.',
    ar: 'لا توجد اتصالات في المخطط تشير إلى هذا المحول.',
  },
  integrationMappedFields: { en: 'mapped fields', ar: 'حقول مربوطة' },
  integrationNotFound: { en: 'Integration not found', ar: 'التكامل غير موجود' },
  integrationNotFoundHint: {
    en: 'This adapter id is not present in the integration catalog.',
    ar: 'معرّف المحول هذا غير موجود في سجل التكاملات.',
  },
  backToIntegrations: { en: 'Back to integrations', ar: 'العودة إلى التكاملات' },

  handover: { en: 'Handover inbox', ar: 'صندوق التحويل' },
  handoverTitle: { en: 'Citizens waiting for a human', ar: 'متعاملون بانتظار موظف' },
  handoverEmpty: { en: 'No handover requests right now.', ar: 'لا توجد طلبات تحويل حالياً.' },
  handoverReply: { en: 'Send reply', ar: 'إرسال الرد' },
  handoverReturnAi: { en: 'Return to AI', ar: 'إعادة للمساعد الذكي' },
  handoverReplyPlaceholder: { en: 'Type your reply to the citizen…', ar: 'اكتب ردك للمتعامل…' },
  pendingHuman: { en: 'Waiting', ar: 'بانتظار' },
  withHuman: { en: 'With staff', ar: 'مع موظف' },

  // Agent desk
  handoverSubtitle: {
    en: 'Live queue, encrypted transcripts, clear ownership and the citizen’s open application.',
    ar: 'قائمة مباشرة ومحادثات مشفرة وملكية واضحة وطلب المتعامل المفتوح.',
  },
  handoverDeskLiveQueue: { en: 'Live queue', ar: 'قائمة المحادثات' },
  handoverDeskActiveContacts: { en: 'active conversations', ar: 'محادثات نشطة' },
  handoverDeskSearch: {
    en: 'Search name, phone, reference…',
    ar: 'ابحث بالاسم أو الهاتف أو المرجع…',
  },
  handoverDeskSearchLabel: { en: 'Search the live queue', ar: 'البحث في القائمة المباشرة' },
  handoverDeskNoMatch: {
    en: 'No conversations match this view.',
    ar: 'لا توجد محادثات تطابق هذا العرض.',
  },
  handoverFilterAll: { en: 'All', ar: 'الكل' },
  handoverFilterWaiting: { en: 'Waiting', ar: 'انتظار' },
  handoverFilterMine: { en: 'Mine', ar: 'لي' },
  handoverFilterLate: { en: 'Late', ar: 'متأخر' },
  handoverMetricWaiting: { en: 'Waiting for a person', ar: 'بانتظار موظف' },
  handoverMetricWaitingHint: {
    en: 'Unclaimed in the live queue',
    ar: 'غير مستلمة في القائمة المباشرة',
  },
  handoverMetricClaimed: { en: 'Being handled', ar: 'قيد المعالجة' },
  handoverMetricOwnedByYou: { en: 'owned by you', ar: 'بملكيتك' },
  handoverMetricLongestWait: { en: 'Longest wait', ar: 'أطول انتظار' },
  handoverMetricLongestWaitHint: {
    en: 'The citizen who has waited most',
    ar: 'المتعامل الأطول انتظاراً',
  },
  handoverMetricBreached: { en: 'Past 10 minutes', ar: 'تجاوز 10 دقائق' },
  handoverMetricBreachedHint: { en: 'Needs picking up now', ar: 'تحتاج استلاماً فورياً' },
  handoverSelectConversation: { en: 'Select a conversation', ar: 'اختر محادثة' },
  handoverSelectConversationHint: {
    en: 'Pick someone from the queue. The transcript updates live.',
    ar: 'اختر متعاملاً من القائمة. ستُحدَّث المحادثة مباشرة.',
  },
  handoverClaim: { en: 'Claim', ar: 'استلام' },
  handoverClaimed: { en: 'Conversation claimed', ar: 'تم استلام المحادثة' },
  handoverRelease: { en: 'Release', ar: 'إخلاء' },
  handoverReleased: { en: 'Returned to the queue', ar: 'أعيدت إلى القائمة' },
  handoverResolved: { en: 'Returned to the assistant', ar: 'تمت الإعادة للمساعد' },
  handoverClaimToReply: { en: 'Claim this conversation to reply.', ar: 'استلم المحادثة للرد.' },
  handoverOwnedBy: { en: 'Owned by', ar: 'مستلمة بواسطة' },
  handoverUnassigned: { en: 'Unassigned', ar: 'غير مسندة' },
  handoverOwner: { en: 'Owner', ar: 'المسؤول' },
  handoverAttach: { en: 'Attach file', ar: 'إرفاق ملف' },
  handoverSendHint: {
    en: 'Enter to send · Shift+Enter for a new line',
    ar: 'Enter للإرسال · Shift+Enter لسطر جديد',
  },
  handoverNewRequest: { en: 'New handover request', ar: 'طلب تحويل جديد' },
  handoverQueuePosition: { en: 'Queue position', ar: 'الترتيب في القائمة' },
  handoverTold: { en: 'Citizen is told', ar: 'ما يراه المتعامل' },
  handoverTyping: { en: 'Typing', ar: 'يكتب' },
  handoverCitizen: { en: 'Citizen', ar: 'المتعامل' },
  handoverNoPhone: { en: 'No phone', ar: 'لا يوجد هاتف' },
  handoverName: { en: 'Name', ar: 'الاسم' },
  handoverLanguage: { en: 'Language', ar: 'اللغة' },
  handoverChannel: { en: 'Channel', ar: 'القناة' },
  handoverPhone: { en: 'Phone', ar: 'الهاتف' },
  handoverWaitTime: { en: 'Waiting for', ar: 'مدة الانتظار' },
  handoverTransfer: { en: 'Transfer to a colleague', ar: 'تحويل إلى زميل' },
  handoverTransferAction: { en: 'Transfer', ar: 'تحويل' },
  handoverTransferred: { en: 'Transferred', ar: 'تم التحويل' },
  handoverCxoneStatus: { en: 'Status', ar: 'الحالة' },
  handoverCxoneAgent: { en: 'Agent', ar: 'الموظف' },
  handoverCxoneQueue: { en: 'Routing queue', ar: 'قائمة التوجيه' },
  handoverCxoneSurface: { en: 'Agent surface', ar: 'واجهة الموظف' },
  handoverCxoneSynced: { en: 'Last synchronized', ar: 'آخر مزامنة' },

  // Suggested replies
  handoverSuggestions: { en: 'Suggested replies', ar: 'ردود مقترحة' },
  handoverSuggestionsHint: {
    en: 'Drafts only — read them, edit them, then send.',
    ar: 'مسودات فقط — اقرأها وعدّلها ثم أرسلها.',
  },
  handoverSuggestionsThinking: { en: 'Drafting…', ar: 'يجري إعداد المسودات…' },
  handoverSuggestionsNone: {
    en: 'No draft this time. Write the reply yourself.',
    ar: 'لا توجد مسودة هذه المرة. اكتب الرد بنفسك.',
  },
  handoverSuggestionsRefresh: { en: 'Redraft', ar: 'إعادة الصياغة' },
  handoverSuggestionUse: { en: 'Use this draft', ar: 'استخدم هذه المسودة' },

  // Application sidebar
  handoverTabApplication: { en: 'Application', ar: 'الطلب' },
  handoverTabCitizen: { en: 'Citizen', ar: 'المتعامل' },
  handoverTabCxone: { en: 'CXone', ar: 'CXone' },
  handoverNoApplication: {
    en: 'This citizen has no application open — they may just be asking a question.',
    ar: 'لا يوجد طلب مفتوح لهذا المتعامل — قد يكون لديه استفسار فقط.',
  },
  handoverApplicationComplete: {
    en: 'Every required answer is in.',
    ar: 'تم استيفاء جميع الإجابات المطلوبة.',
  },
  handoverStillNeeded: { en: 'Still needed', ar: 'مطلوب بعد' },
  handoverAnswered: { en: 'answered', ar: 'مُجاب' },
  handoverFieldSaved: { en: 'Saved', ar: 'تم الحفظ' },
  handoverFieldSave: { en: 'Save', ar: 'حفظ' },
  handoverFieldMinistry: {
    en: 'From a ministry record — read only',
    ar: 'من سجل الوزارة — للقراءة فقط',
  },
  handoverFieldByStaff: { en: 'Entered by staff', ar: 'أُدخل بواسطة موظف' },
  handoverDocuments: { en: 'Documents', ar: 'المستندات' },
  handoverDocumentAttached: { en: 'attached', ar: 'مرفق' },
  handoverDocumentLinked: { en: 'Held by the ministry', ar: 'محفوظ لدى الوزارة' },
  handoverDocumentMissing: { en: 'Not yet received', ar: 'لم يُستلم بعد' },
  handoverBlocked: { en: 'Cannot be filed yet', ar: 'لا يمكن تقديمه بعد' },
  handoverOtherAnswers: { en: 'Answers already given', ar: 'إجابات مُسجّلة' },
  handoverSelectOption: { en: 'Select…', ar: 'اختر…' },
  handoverYes: { en: 'Yes', ar: 'نعم' },
  handoverNo: { en: 'No', ar: 'لا' },

  proactive: { en: 'Renewal outreach', ar: 'تذكير التجديد' },
  proactiveTitle: { en: 'Proactive renewal reminders', ar: 'تذكيرات التجديد الاستباقية' },
  proactiveScan: { en: 'Run renewal scan', ar: 'تشغيل فحص التجديد' },
  proactiveDue: { en: 'Permits due for renewal', ar: 'تصاريح مستحقة للتجديد' },
  proactiveOffered: { en: 'Renewal offers sent', ar: 'عروض تجديد مُرسلة' },
  proactiveEmpty: { en: 'No renewals due in this window.', ar: 'لا تجديدات مستحقة في هذه الفترة.' },
  withinDays: { en: 'Within days', ar: 'خلال أيام' },

  viewTranscript: { en: 'View transcript', ar: 'عرض المحادثة' },
  byChannel: { en: 'By channel', ar: 'حسب القناة' },
  chartCount: { en: 'Count', ar: 'العدد' },

  // dashboard elevation (plan points 19–23)
  timeWindow: { en: 'Time window', ar: 'الفترة الزمنية' },
  window24h: { en: '24h', ar: '٢٤ س' },
  window7d: { en: '7d', ar: '٧ أ' },
  window30d: { en: '30d', ar: '٣٠ ي' },
  applicationVolume: { en: 'Applications', ar: 'الطلبات' },
  applicationVolumeHint: { en: 'Started in the selected window', ar: 'بدأت خلال الفترة المحددة' },
  slaRiskStrip: { en: 'SLA risk by queue', ar: 'مخاطر التأخير حسب القائمة' },
  slaRiskStripHint: {
    en: 'Overdue share of open work per review queue — select a segment to open that queue.',
    ar: 'حصة العمل المتأخر في كل قائمة مراجعة — اختر جزءاً لفتح تلك القائمة.',
  },
  slaRiskLegendOk: { en: 'On track', ar: 'ضمن المهلة' },
  slaRiskLegendWarn: { en: 'At risk', ar: 'معرضة للخطر' },
  slaRiskLegendCritical: { en: 'Critical', ar: 'حرجة' },
  needsYou: { en: 'Needs you', ar: 'بانتظارك' },
  needsYouHint: {
    en: 'Your claimed conversations, approvals awaiting your decision and open service drafts.',
    ar: 'محادثاتك المستلمة والاعتمادات بانتظار قرارك ومسودات الخدمات المفتوحة.',
  },
  myConversations: { en: 'My claimed conversations', ar: 'محادثاتي المستلمة' },
  myApprovals: { en: 'Approvals awaiting me', ar: 'اعتمادات بانتظاري' },
  myDrafts: { en: 'Open service drafts', ar: 'مسودات خدمات مفتوحة' },
  viewAll: { en: 'View all', ar: 'عرض الكل' },
  nothingHere: { en: 'Nothing right now', ar: 'لا شيء حالياً' },
  activityPulse: { en: 'Activity pulse', ar: 'نبض النشاط' },
  activityPulseHint: { en: 'Latest audited platform events.', ar: 'أحدث الأحداث المدققة في المنصة.' },
  activityEmpty: { en: 'No recent activity', ar: 'لا يوجد نشاط حديث' },

  // queues elevation (plan points 24–26)
  savedViews: { en: 'Saved views', ar: 'عروض محفوظة' },
  slaRiskView: { en: 'SLA risk', ar: 'معرضة للتأخير' },
  mineView: { en: 'Mine', ar: 'مهامي' },
  unassignedView: { en: 'Unassigned', ar: 'غير مسندة' },
  queueFilterLabel: { en: 'Queue', ar: 'القائمة' },
  densityLabel: { en: 'Density', ar: 'الكثافة' },
  densityComfort: { en: 'Comfort', ar: 'مريحة' },
  densityCompact: { en: 'Compact', ar: 'مدمجة' },
  openAction: { en: 'Open', ar: 'فتح' },

  // case elevation (plan points 27–30)
  sectionNavigator: { en: 'Section navigator', ar: 'متصفح الأقسام' },
  reviewProgress: { en: 'Review progress', ar: 'تقدم المراجعة' },
  pendingState: { en: 'Pending', ar: 'قيد الانتظار' },
  decisionBarHint: {
    en: 'Decides the highlighted section — shortcuts A agree · C correct · R return',
    ar: 'يقرر القسم المحدد — اختصارات A موافقة · C تصحيح · R إعادة',
  },
  previousValue: { en: 'Current value', ar: 'القيمة الحالية' },

  simPay: { en: 'Pay (sandbox)', ar: 'الدفع (تجريبي)' },
  simUseTestCard: { en: 'Use test card', ar: 'استخدم بطاقة تجريبية' },

  // approvals elevation (plan points 31–34)
  riskTier: { en: 'Risk tier', ar: 'مستوى المخاطر' },
  tierLow: { en: 'Low', ar: 'منخفضة' },
  tierStandard: { en: 'Standard', ar: 'قياسية' },
  tierMedium: { en: 'Medium', ar: 'متوسطة' },
  tierElevated: { en: 'Elevated', ar: 'مرتفعة' },
  tierHigh: { en: 'High', ar: 'عالية' },
  tierCritical: { en: 'Critical', ar: 'حرجة' },
  oldestFirst: { en: 'Oldest first', ar: 'الأقدم أولاً' },
  ageMinute: { en: 'm', ar: ' د' },
  ageHour: { en: 'h', ar: ' س' },
  ageDay: { en: 'd', ar: ' ي' },
  ageLabel: { en: 'Waiting time', ar: 'مدة الانتظار' },
  ageOver48: { en: 'Waiting more than 48 hours', ar: 'ينتظر أكثر من 48 ساعة' },
  ageOver96: { en: 'Waiting more than 96 hours', ar: 'ينتظر أكثر من 96 ساعة' },
  approveSelected: { en: 'Approve selected', ar: 'اعتماد المحدد' },
  selectForBulk: { en: 'Select for bulk approval', ar: 'تحديد للاعتماد الجماعي' },
  bulkLowOnly: {
    en: 'Bulk approval is limited to the lowest risk tier in the inbox.',
    ar: 'الاعتماد الجماعي محدود بأدنى مستوى مخاطر في الصندوق.',
  },
  bulkConfirmTitle: { en: 'Approve selected requests', ar: 'اعتماد الطلبات المحددة' },
  bulkConfirmHint: {
    en: 'Each request below will be approved and executed in order. This cannot be undone.',
    ar: 'سيتم اعتماد كل طلب أدناه وتنفيذه بالترتيب. لا يمكن التراجع عن هذا الإجراء.',
  },
  bulkProgress: { en: 'Approving', ar: 'جارٍ الاعتماد' },
  bulkDone: { en: 'Selected requests approved and executed', ar: 'تم اعتماد الطلبات المحددة وتنفيذها' },
  confirm: { en: 'Confirm', ar: 'تأكيد' },
  more: { en: 'more', ar: 'أخرى' },
  viewAudit: { en: 'View audit trail', ar: 'عرض سجل التدقيق' },
  auditTitle: { en: 'Approval audit trail', ar: 'سجل تدقيق الاعتماد' },
  auditHint: {
    en: 'Hash-chained entries related to this request and its subject.',
    ar: 'قيود مرتبطة تشفيرياً بهذا الطلب وموضوعه.',
  },
  auditEmpty: { en: 'No audit entries found for this item', ar: 'لا توجد قيود تدقيق لهذا العنصر' },
  close: { en: 'Close', ar: 'إغلاق' },
  showUnchanged: { en: 'Show unchanged', ar: 'إظهار غير المتغيّر' },
  hideUnchanged: { en: 'Hide unchanged', ar: 'إخفاء غير المتغيّر' },

  // customer 360 elevation (plan points 36–39)
  relationshipTimeline: { en: 'Relationship timeline', ar: 'الخط الزمني للعلاقة' },
  relationshipTimelineHint: {
    en: 'Applications, conversations, notes and tasks in one chronological feed.',
    ar: 'الطلبات والمحادثات والملاحظات والمهام في سجل زمني واحد.',
  },
  crmTimelineEmpty: { en: 'No relationship events yet', ar: 'لا توجد أحداث للعلاقة بعد' },
  tlApplicationCreated: { en: 'Application created', ar: 'إنشاء طلب' },
  tlApplicationSubmitted: { en: 'Application submitted', ar: 'تقديم الطلب' },
  tlApplicationDecision: { en: 'Decision recorded', ar: 'تسجيل قرار' },
  tlConversation: { en: 'Conversation started', ar: 'بدء محادثة' },
  tlNote: { en: 'Internal note', ar: 'ملاحظة داخلية' },
  tlTaskCreated: { en: 'Task created', ar: 'إنشاء مهمة' },
  tlTaskCompleted: { en: 'Task completed', ar: 'إكمال مهمة' },
  showMore: { en: 'Show more', ar: 'عرض المزيد' },
  showLess: { en: 'Show less', ar: 'عرض أقل' },
  olderEvents: { en: 'older events', ar: 'أحداث أقدم' },
  quickNote: { en: 'Quick note', ar: 'ملاحظة سريعة' },
  quickNotePlaceholder: { en: 'Type a note or pick a template…', ar: 'اكتب ملاحظة أو اختر قالباً…' },
  tplCalled: { en: 'Called customer', ar: 'اتصال بالمتعامل' },
  tplCalledBody: {
    en: 'Called the customer and discussed the request status.',
    ar: 'تم الاتصال بالمتعامل ومناقشة حالة الطلب.',
  },
  tplDocs: { en: 'Requested documents', ar: 'طلب مستندات' },
  tplDocsBody: {
    en: 'Requested the missing documents from the customer.',
    ar: 'تم طلب المستندات الناقصة من المتعامل.',
  },
  tplFollowUp: { en: 'Follow-up scheduled', ar: 'جدولة متابعة' },
  tplFollowUpBody: {
    en: 'Scheduled a follow-up with the customer.',
    ar: 'تمت جدولة متابعة مع المتعامل.',
  },
  noteSaved: { en: 'Note saved', ar: 'تم حفظ الملاحظة' },
  consentManager: { en: 'Consent manager', ar: 'إدارة الموافقات' },
  consentManagerHint: {
    en: 'PDPL consent records granted by the customer.',
    ar: 'سجلات موافقة حماية البيانات الممنوحة من المتعامل.',
  },
  consentReadOnlyNote: {
    en: 'Consents are granted and revoked from citizen channels only — this register is read-only under PDPL.',
    ar: 'تُمنح الموافقات وتُلغى من قنوات المتعامل فقط — هذا السجل للقراءة فقط وفق قانون حماية البيانات.',
  },
  granted: { en: 'Granted', ar: 'مُنحت' },
  revokedOn: { en: 'Revoked', ar: 'أُلغيت' },
  consentVia: { en: 'via', ar: 'عبر' },
  vipBadge: { en: 'VIP', ar: 'مميز' },
  atRiskBadge: { en: 'At risk', ar: 'معرّض للخطر' },
  vipRule: {
    en: 'VIP: 3+ approved applications or 5,000+ AED captured',
    ar: 'مميز: 3+ طلبات معتمدة أو أكثر من 5,000 درهم محصلة',
  },
  atRiskRule: {
    en: 'At risk: open complaints or failed payments on record',
    ar: 'معرّض للخطر: توجد شكاوى مفتوحة أو مدفوعات فاشلة مسجلة',
  },
  approvedApps: { en: 'approved applications', ar: 'طلبات معتمدة' },
  capturedValue: { en: 'captured', ar: 'محصلة' },
  openComplaintsLabel: { en: 'open complaints', ar: 'شكاوى مفتوحة' },
  failedPaymentsLabel: { en: 'failed payments', ar: 'مدفوعات فاشلة' },
} satisfies Record<string, Localized>;
